export default class Forms {
    constructor() {
        this.init();
    }

    init() {

        // === CF7 FORM NOT-VALID ===
        function manageClass(element) {
            const formGroup = element.closest('.form-group');
            if (element.classList.contains('wpcf7-not-valid')) {
                formGroup.classList.add('not-valid');
            } else {
                formGroup.classList.remove('not-valid');
            }
        }
        function removeClassesOnFocusOrClick(event) {
            const inputElement = event.target;
            const formGroup = inputElement.closest('.form-group');
            const notValidTip = inputElement.closest('.wpcf7-form-control-wrap').querySelector('.wpcf7-not-valid-tip');

            inputElement.classList.remove('wpcf7-not-valid');
            formGroup.classList.remove('not-valid');

            if( notValidTip ) {
                notValidTip.style.display = 'none';
            }
        }
        const config = {
            attributes: true,
            attributeFilter: ['class'],
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                manageClass(mutation.target);
            });
        });
        const formControls = document.querySelectorAll('.wpcf7-form-control');

        formControls.forEach((formControl) => {
            observer.observe(formControl, config);
            formControl.addEventListener('click', removeClassesOnFocusOrClick);
            formControl.addEventListener('focus', removeClassesOnFocusOrClick);
        });

    }

}